var CommunityShortcut = React.createClass({
  propTypes: {
    communities: React.PropTypes.array.isRequired,
  },
  getItem(comm) {
    let imagePath = Config.contextPath + (RA.Utils.isNotBlank(comm.image) ? comm.image : '/app/images/default-community.png');
    let url = `${Config.contextPath}/${Config.portalInterface}/?tabname=community&communityID=${comm.id}` + simplifiedSocialLayoutParam + launchLinksInNewWindowParam;
    let questionLabel = comm.hits == 1 ? "question" : "questions";
    let topicLabel = comm.topics.length == 1 ? "topic" : "topics";

    return (
      <div className="shortcut-panel__item" key={comm.id}>
        <a href={url} className="shortcut-panel__link">
          <div className="shortcut-panel__icon">
            <div className="shortcut-panel__image-wrap">
              <img src={imagePath} className="shortcut-panel__image" alt="" />
            </div>
          </div>
          <div className="shortcut-panel__label">
            {comm.name}
          </div>
        </a>
      </div>
    );
  },
  render() {
    let items = this.props.communities.map(this.getItem);

    return <div className="shortcut-panel__list">{items}</div>;
  }
});
